"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[83648],{

/***/ 783648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BestSellingProductsBlock": function() { return /* binding */ BestSellingProductsBlock; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88837);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(309396);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(997441);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(185081);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(788813);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(428247);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








const BestSellingProductsBlock = (param)=>{
    let { block , productPerView , ssrProducts =[]  } = param;
    var ref, ref1, ref2, ref3;
    const { result: bestSellingData , isLoading  } = (0,hooks__WEBPACK_IMPORTED_MODULE_2__/* .useSearch */ .Rx)(block && _objectSpreadProps(_objectSpread({}, block.cookedData.paramsObject), {
        blockId: block.id,
        pageSize: constants_index__WEBPACK_IMPORTED_MODULE_3__/* .LIMIT_ITEM_PER_PAGE_PRODUCT_LIST */ .Fl
    }), {
        products: ssrProducts
    });
    if (!isLoading && !(bestSellingData === null || bestSellingData === void 0 ? void 0 : (ref = bestSellingData.products) === null || ref === void 0 ? void 0 : ref.length)) return null;
    const link = (block === null || block === void 0 ? void 0 : block.viewMoreUrl) || "".concat((0,helpers__WEBPACK_IMPORTED_MODULE_4__/* .convertObjectDiscoveryToQueryStringSearch */ .jx)(_objectSpread({}, (0,helpers__WEBPACK_IMPORTED_MODULE_4__/* .cookDiscoveryFilter */ .Eo)((ref1 = block.cookedData.paramsObject) === null || ref1 === void 0 ? void 0 : ref1.filter), (ref2 = block.cookedData) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.paramsObject) === null || ref3 === void 0 ? void 0 : ref3.sorting)));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_5__/* .ProductCarouselWithHeader */ .B, {
        header: {
            title: block.label,
            titleColor: "white",
            link: {
                color: "white",
                href: link
            }
        },
        productsPerRow: productPerView || 5,
        products: (bestSellingData === null || bestSellingData === void 0 ? void 0 : bestSellingData.products) || [],
        background: block.backgroundImageUrl,
        virtual: (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .isServerless */ .ep)(),
        tracking: (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_7__/* .getTrackingData */ .O5)({
            regionName: "".concat(block.label, "HorizontalBlock"),
            isTrackContent: true
        })
    });
};


/***/ })

}]);